import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AuthenticationProvider } from './Context/AuthenticationContext';
import * as serviceWorker from './serviceWorker';
import { AppThemeProvider, useThemeMode } from './theme';
import { Toaster } from 'sonner';

import './index.css';

function AppToaster() {
  const { effective } = useThemeMode();
  return (
    <Toaster
      theme={effective}
      position="bottom-right"
      richColors
      closeButton
      expand={false}
      visibleToasts={4}
      toastOptions={{
        duration: 4000,
        style: { fontFamily: 'inherit' },
      }}
    />
  );
}

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <AppThemeProvider>
    <AuthenticationProvider>
      <App />
    </AuthenticationProvider>
    <AppToaster />
  </AppThemeProvider>
);

serviceWorker.unregister();
